import { parseProjectKeyIdFromGatewayCredential } from './parseProjectKeyIdFromGatewayCredential'

type GatewayProjectKeySource = {
  gatewayKey?: string | null
}

export function resolveGatewayProjectKeyId(gateway: GatewayProjectKeySource): string {
  return parseProjectKeyIdFromGatewayCredential(gateway.gatewayKey) ?? ''
}

export function gatewayMatchesProjectKey(gateway: GatewayProjectKeySource, projectKeyId: string): boolean {
  const normalizedProjectKeyId = projectKeyId.trim()

  if (!normalizedProjectKeyId) {
    return true
  }

  const gatewayProjectKeyId = resolveGatewayProjectKeyId(gateway)
  if (!gatewayProjectKeyId) {
    return false
  }

  return gatewayProjectKeyId === normalizedProjectKeyId
}
